import { useEffect, useRef, useContext } from 'preact/hooks';
import { useSignal } from '@preact/signals';
import { MessageItem } from './MessageItem.jsx';
import { ChatContext } from '../hooks/context.js';
import { dateLabel } from '../utils/helpers.js';

function DateSeparator({ ts, locale }) {
  return (
    <div class="mc-date-sep">
      <span>{dateLabel(ts, locale)}</span>
    </div>
  );
}

export function MessageList({ messages, isFloatpanel }) {
  const { cfg } = useContext(ChatContext);
  const listRef = useRef(null);

  // Scroll to bottom when messages change
  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [messages]);

  const items = [];
  let lastDate = null;

  messages.forEach((msg, i) => {
    const prevMsg   = i > 0 ? messages[i - 1] : null;
    const thisDate  = new Date(msg.timestamp).toDateString();
    const isSpecial = msg.role === 'system' || msg.role === 'system-error';

    if (!isSpecial && thisDate !== lastDate) {
      items.push(<DateSeparator key={`sep-${msg.id}`} ts={msg.timestamp} locale={cfg.locale} />);
      lastDate = thisDate;
    }
    items.push(<MessageItem key={msg.id} msg={msg} prevMsg={prevMsg} cfg={cfg} />);
  });

  return (
    <div
      ref={listRef}
      class={`mc-messages${isFloatpanel ? ' mc-gpanel-messages' : ''}`}
      role="log"
      aria-live="polite"
      aria-label="Chat messages"
      part="messages"
    >
      {isFloatpanel && <div class="mc-gmsg-spacer" aria-hidden="true" />}
      {items}
    </div>
  );
}
